import styled from 'styled-components/macro';

export const Wrapper = styled.div<{ isDisabled: boolean }>`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'auto')};
  pointer-events: ${(props) => (props.isDisabled ? 'none' : 'auto')};
`;

export const DragWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  max-width: 110px;
  max-height: 110px;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
  cursor: grab;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;
